module.exports = __webpack_public_path__ + "62dae0e6f69dcb0ded14869c04f8553a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/plus_2.svg
// module id = 226
// module chunks = 0